import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

// ==================== Config Notif (SSO Notifikasi) ====================
export interface ConfigNotif {
    id_config_notif: number;
    system_code: string;
    notif_code: string;
    user: string;
    url: string;
    is_active: boolean | number;
    has_pass: boolean;
}
export interface ConfigNotifPayload {
    system_code: string;
    notif_code: string;
    user: string;
    pass?: string;
    url: string;
    is_active: boolean;
}

export const useConfigNotifs = () =>
    useQuery<ConfigNotif[]>({
        queryKey: ["config-notif"],
        queryFn: async () => (await axiosClient.get("/pengaturan/notif")).data,
    });

export const useCreateConfigNotif = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (payload: ConfigNotifPayload) => (await axiosClient.post("/pengaturan/notif", payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-notif"] }),
    });
};
export const useUpdateConfigNotif = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: ConfigNotifPayload }) =>
            (await axiosClient.put(`/pengaturan/notif/${id}`, payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-notif"] }),
    });
};
export const useDeleteConfigNotif = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => (await axiosClient.delete(`/pengaturan/notif/${id}`)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-notif"] }),
    });
};

// ==================== Config Services (Layanan Eksternal) ====================
export interface ConfigServices {
    id_config_services: number;
    services_login: string;
    services_url: string;
    services_data: string;
    services_username: string;
    services_id_pengguna: string | null;
    is_active: boolean | number;
    has_password: boolean;
}
export interface ConfigServicesPayload {
    services_login: string;
    services_url: string;
    services_data: string;
    services_username: string;
    services_password?: string;
    services_id_pengguna?: string | null;
    is_active: boolean;
}

export const useConfigServices = () =>
    useQuery<ConfigServices[]>({
        queryKey: ["config-services"],
        queryFn: async () => (await axiosClient.get("/pengaturan/services")).data,
    });

export const useCreateConfigServices = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (payload: ConfigServicesPayload) => (await axiosClient.post("/pengaturan/services", payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-services"] }),
    });
};
export const useUpdateConfigServices = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: ConfigServicesPayload }) =>
            (await axiosClient.put(`/pengaturan/services/${id}`, payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-services"] }),
    });
};
export const useDeleteConfigServices = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => (await axiosClient.delete(`/pengaturan/services/${id}`)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-services"] }),
    });
};

// ==================== Config Static (Server Statis) ====================
export interface ConfigStatic {
    id_config_static: number;
    hostname: string;
    username: string;
    default_dir: string | null;
    autoconnect: string | null;
    server: string | null;
    system: string | null;
    is_active: boolean | number;
    has_password: boolean;
}
export interface ConfigStaticPayload {
    hostname: string;
    username: string;
    password?: string;
    default_dir?: string | null;
    autoconnect?: string | null;
    server?: string | null;
    system?: string | null;
    is_active: boolean;
}

export const useConfigStatics = () =>
    useQuery<ConfigStatic[]>({
        queryKey: ["config-static"],
        queryFn: async () => (await axiosClient.get("/pengaturan/static")).data,
    });

export const useCreateConfigStatic = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (payload: ConfigStaticPayload) => (await axiosClient.post("/pengaturan/static", payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-static"] }),
    });
};
export const useUpdateConfigStatic = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: ConfigStaticPayload }) =>
            (await axiosClient.put(`/pengaturan/static/${id}`, payload)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-static"] }),
    });
};
export const useDeleteConfigStatic = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => (await axiosClient.delete(`/pengaturan/static/${id}`)).data,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["config-static"] }),
    });
};
